<template>
    <layout
        :showuserinfo="false"
        :title="`Cukai Tanah: ${cukais.no_hm ?? 'Loading...'} `"
        :crumbs="crumbs"
    >
        <w-button class="mb3" text @click="kembali()">
            &#60;&#60; Kembali
        </w-button>
        <w-flex class="align-center justify-center" v-if="loading">
            <w-spinner />
        </w-flex>
        <w-card v-if="!loading">
            <hakmilik :cukai="cukais" />
            <card :cukai="cukais" :cukais="cukai" :sejBayar="sejBayar"/>
            <w-flex class="justify-end mt3">

                <w-button class="mr3" @click="janaBil()" width="10em"
                    >Jana Bil</w-button
                >

                <!-- <w-button class="mr3" @click="janaBilNewYear()" width="10em"
                    >Jana Bil {{ nextYear }}</w-button
                > -->
                <w-button class="mr3" @click="janaBil2()" width="10em"
                    >Penyata Cukai</w-button
                >
                 <w-button class="mr3" @click="syerHakmilik()" width="10em"
                    >Syer Hakmilik</w-button
                >

            </w-flex>
        </w-card>
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import Card from "../Component/Card";
export default {
    extends: ZResource,
    props: {
        hakMilik: [Object, Array],
    },
    components: {
        Hakmilik,
        Card,
    },

    data() {
        return {
            showDialog: true,
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
                {
                    label: "Butiran Hak Milik",
                    route: "/cukai-tanah/butiran-cukai",
                },
            ],
            form: {},
            cukai: [[]],
            cukais: [],
            loading: true,
            sejBayar:[],
        };
    },
    computed: {
        nextYear() {
            return new Date().getFullYear() + 1
        }
    },

    methods: {
        semakHm(x){
            if(x.no_hm_sebelum!=null && x.no_hm_sebelum != 'Tiada'){
                this.semakBayar(x.no_hm_sebelum);
            }
        },
        async semakBayar(no_hm){
            // console.log(no_hm);
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/sejarahBayaran`,
                params: {
                    no_hm:no_hm,
                },
                responseType: "json",
            }).then((e) => {
                // console.log(e.data);
                // this.sejBayar.items = e.data;
                this.sejBayar = e.data.map((e) => {
                        return {
                            cara_bayar:e.cara_bayar.keterangan,
                            no_resit:e.no_resit,
                            tarikh_bayar:e. tarikh_bayar,
                            no_rujukan:e.no_rujukan,
                            amaun:e.amaun,
                            tarikh_batal:e.tarikh_batal,
                            // kerani:e.user[0].no_id,
                            status:e.status.keterangan,
                        };
                });
                // console.log(this.sejBayar);
            });
        },
        async searchCukai() {
            this.searching = true;
            const l = {
                kategoriCarian: "1",
                formOption: "option1",
                barcode: this.hakMilik,
                kodDaerah: "01",
            };
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: l,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        this.cukai = e.data;
                        this.cukais = e.data[0];
                        this.semakHm(e.data[0]);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        janaBil() {
            var url1 = `${this.apiBaseUrl}/cukai/jana-bil?no_hm=${this.cukais.no_hm}`;
            window.open(url1, "_blank");
        },
        janaBilNewYear() {
            var url1 = `${this.apiBaseUrl}/cukai/jana-bil-newyear?no_hm=${this.cukais.no_hm}`;
            window.open(url1, "_blank");
        },
        janaBil2() {
            var url1 = `${this.apiBaseUrl}/cukai/maklumat-cukai-tanah?nohm=${this.cukais.no_hm}`;
            window.open(url1, "_blank");
        },
        syerHakmilik() {
            var url1 = `${this.apiBaseUrl}/cukai/maklumat-syer-cukai-tanah?nohm=${this.cukais.no_hm}`;
            window.open(url1, "_blank");
        },
        kembali() {
            window.history.back();
        },
    },
    watch: {},
    mounted() {
        this.searchCukai();

    },
};
</script>
